<loader [big]="true"></loader>
<div [ngClass]="{ 'blurIt': !noBlurClass }" class="menu-container">
  <ibex-img *ngIf="logoLayer" [src]="logoLayer" class="logo-layer"></ibex-img>

  <default-launcher-header [clockColor]="clockColor" [logoPosition]="logoPosition" clockId="menu"></default-launcher-header>

  <div [ngClass]="{barrierFree: barrierFreeModeActive}" class="arrows left">
    <div class="top arrow"><ibex-icon name="angle-up-two" variant="blank"></ibex-icon></div>
    <div class="bottom arrow"><ibex-icon name="angle-down-two" variant="blank"></ibex-icon></div>
  </div>

  <div class="content-container" id="slides-container" *ngIf="!isLoading">
    <div *ngFor="let group of groupedApps" class="slide" [ngClass]="{ items3: group.length <= 3, items6: group.length <= 6, items9: group.length <= 9, items12: group.length <= 12 }">
      <div *ngFor="let app of group" (click)="openApp(app)" class="app" [class.empty]="app?.empty">
        <ibex-icon [name]="app?.icon"></ibex-icon>
        <div class="app-title">{{ app?.title }}</div>
      </div>
    </div>
  </div>

  <div [ngClass]="{barrierFree: barrierFreeModeActive}" class="arrows right">
    <div class="top arrow"><ibex-icon name="angle-up-two" variant="blank"></ibex-icon></div>
    <div class="bottom arrow"><ibex-icon name="angle-down-two" variant="blank"></ibex-icon></div>
  </div>

  <loader *ngIf="!apps || !!isLoading" [big]="true"></loader>

  <div class="buttons left">
    <div class="button small languages" *ngIf="languages?.length > 1" (click)="languageSelectionOpen = !languageSelectionOpen"
         [class.open]="languageSelectionOpen">
      <div class="inner-button">
        <ibex-icon *ngFor="let lang of languages" [name]="lang" (click)="updateLanguage(lang)"
                   [ngClass]="{ selected: lang === language, active: lang === language || languageSelectionOpen }"></ibex-icon>
      </div>
    </div>
    <div class="button" (click)="openOverlay('share')" [class.invisible]="!hasIbexsmart">
      <ibex-icon class="text-icon" name="{{'apps.share.buttonIcon' | translate | async}}"></ibex-icon>
      <div [innerHTML]="'apps.share.buttonTitle' | translate | async"></div>
    </div>
  </div>

  <div class="buttons right" *ngIf="!disableHelpers || !!isSearchEnabled">
    <div (click)="startHelper('magnifying-glass', $event)" *ngIf="!disableHelpers" class="button small smallGap barrier">
      <ibex-icon class="text-icon" name="search-zoom{{magnifyingGlassActive ? '-contrast' : ''}}"></ibex-icon>
    </div>
    <div (click)="startHelper('contrast', $event)" *ngIf="enableHighContrastMode" class="button small smallGap barrier">
      <ibex-icon class="text-icon" name="contrast{{highContrastModeActive ? '-contrast' : ''}}"></ibex-icon>
    </div>
    <div (click)="startHelper('wheelchair', $event)" *ngIf="enableWheelchairNavigation" class="button small barrier">
      <ibex-icon class="text-icon" name="wheelchair{{barrierFreeModeActive ? '-contrast' : ''}}"></ibex-icon>
    </div>
    <div (click)="openOverlay('search')" *ngIf="isSearchEnabled" class="button small" [class.smallGap]="!disableHelpers">
      <ibex-icon class="text-icon" name="search-2"></ibex-icon>
    </div>
    <div class="button" (click)="closeMenu()">
      <ibex-icon class="text-icon" name="close"></ibex-icon>
      <div>{{ 'general.close' | translate | async }}</div>
    </div>
  </div>
</div>
